import _isString from 'lodash/isString'
import _isEmpty from 'lodash/isEmpty'

export const isNonEmptyString = (value) => {
  return _isString(value) && !_isEmpty(value)
}
